import * as go from 'gojs';

const iteratorToArray = <T>(iterator: go.Iterator<T>) => {
  const result: T[] = [];
  iterator.each((item: T) => result.push(item));
  return result;
};

export const getChildren = (node: go.Node) =>
  iteratorToArray(node.linksConnected.map((link) => link.getOtherNode(node)));

export const getWidthOfAllChildren = (node: go.Node | null) =>
  node
    ? getChildren(node).reduce(
        (acc, val) => (val ? acc + val.actualBounds.width : acc),
        0
      )
    : 0;
